<div style="height: 100%; position: relative;">
    <div class="videos-grid single">
        <div id="participant-video-{{uniqueId}}" class="video-item">
            <video id="video-{{uniqueId}}" autoplay playsinline
                (loadedmetadata)="onVideoDimensionsChange($event)"
                (resize)="onVideoDimensionsChange($event)"></video>
            <audio id="audio-{{uniqueId}}" autoplay></audio>
            <div class="camera-controls" *ngIf="showLocateButton || !showBlackScreen || hasAudioTrackAvailable">
                <button *ngIf="showLocateButton" type="button" class="locate-camera-toggle"
                    (click)="onLocateClick($event)" [matTooltip]="'Locate camera on map' | translate"
                    [attr.aria-label]="'Locate camera on map' | translate">
                    <mat-icon style="font-size: 1.3rem;">place</mat-icon>
                </button>
                <button *ngIf="showStopButton" type="button" class="stop-camera-toggle"
                    (click)="onStopStreamClick($event)" [matTooltip]="'Stop camera' | translate"
                    [attr.aria-label]="'Stop camera' | translate">
                    <mat-icon style="font-size: 1.3rem;">stop</mat-icon>
                </button>
                <button type="button" class="audio-toggle" *ngIf="!showBlackScreen || hasAudioTrackAvailable"
                    (click)="toggleAudio($event)" [attr.aria-label]="isAudioMuted ? 'Unmute stream' : 'Mute stream'">
                    <mat-icon [class.audio-unavailable]="!hasAudioTrackAvailable" style="font-size: 1.3rem;">{{
                        !hasAudioTrackAvailable || isAudioMuted ? 'volume_off'
                        : 'volume_up' }}</mat-icon>
                </button>
            </div>
            <div class="black-screen" *ngIf="showBlackScreen">{{'Not Streaming' | translate}}</div>
        </div>
    </div>
</div>
